<div class="article-container" *ngIf="article">
  <div class="entity-view-title" [ngbTooltip]="article.title" tooltipClass="simple-tooltip" [overflowThreshold]="2"
       overflowTooltip [openDelay]="500">{{ article.title }}</div>
  <div class="d-flex">
    <div class="left-part d-flex flex-column"
         data-cy="article-view-info-section">
      <div class="d-flex justify-content-between pb-4">
        <app-saving-panel data-cy="save-panel-button"
                          [document]="{
                          id: article.id,
                          type: type,
                          title: article.title,
                          snippet: article.snippet,
                          bookmarkPaths: article.bookmarkPaths
      }" (bookmarkPathsUpdated)="bookmarkPathsUpdated(article.id, $event)"></app-saving-panel>
        <app-share-panel
          data-cy="share-panel-button"
          class="sharing-panel"
          [document]="documentToBeShared"
          [withExportPanel]="false"
        />
      </div>
      <app-metadata
        class="pb-2"
        [documentType]="'article'"
        [source]="article.source"
        [territories]="article.territories"
        [publicationDate]="article.publicationDate"></app-metadata>
      <app-task-reminder [documentId]="article.id"></app-task-reminder>
      <references-panel *ngIf="article.impacters.length || fromNewsletter" [references]="article.impacters" [selectable]="fromNewsletter" [ready]="ready"
                        [context]="{ contentType: 'article', docId: article.id, digestResultsId }">
      </references-panel>
    </div>

    <div class="right-part w-100">
      <div class="first-line w-100 position-relative"></div>
      <div [ngClass]="{'load-position': show}">
        <app-loader [show]="show" [inView]="true" [inSearch]="inSearch" [noResult]="searchNotFound"
                    [topChoice]="'top-loader-article'"></app-loader>
        <div class="content">
          <div class="view-content">
            <span class="article-title line-clamp">{{ article.title | uppercase }}</span>
            <div class="search-bar-container" [ngClass]="{'sticky-position' :!show}">
              <app-control-f
                (onPrev)="controlFService.goToSelected($event)"
                (onNext)="controlFService.goToSelected($event)"
                (onSearch)="article.text && controlFService.prev_find($event, articleViewElement,article.text)"
                [totalMatches]="controlFService.totalMatches"
                [documentLoaded]="true">
              </app-control-f>
            </div>
            <app-image-carousel-smart *ngIf="article" [article]="article"></app-image-carousel-smart>
            <div class="text text-justify" data-cy="full-text-article-view"
                 [innerHTML]="article.text ? (article.text | highlight: controlFService.inputSearch | reference: article.impacters): ''"
                 #articleView
            >
            </div>
            <div class="ID-article-0CtgAin" *ngIf="documentProviderId.length>0">ID article : {{ documentProviderId }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
